<template>
  <ul class="social-links">
    <li>
      <b-link v-if="false" @click="handleGoToTwitter" class="twitter">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_670_1422)">
            <path
              d="M12.0005 0C5.3737 0 0.000488281 5.37321 0.000488281 12C0.000488281 18.6268 5.3737 24 12.0005 24C18.6273 24 24.0005 18.6268 24.0005 12C24.0005 5.37321 18.6273 0 12.0005 0ZM17.7675 9.04554C17.7755 9.17143 17.7755 9.30268 17.7755 9.43125C17.7755 13.3634 14.7808 17.8929 9.30852 17.8929C7.62102 17.8929 6.05674 17.4027 4.73888 16.5589C4.97995 16.5857 5.21031 16.5964 5.45674 16.5964C6.8496 16.5964 8.12995 16.125 9.15049 15.3268C7.84335 15.3 6.74513 14.4429 6.37013 13.2643C6.82817 13.3313 7.24067 13.3313 7.7121 13.2107C7.03904 13.074 6.43408 12.7084 6 12.1762C5.56591 11.644 5.32947 10.9779 5.33085 10.2911V10.2536C5.7246 10.4759 6.18799 10.6125 6.67281 10.6313C6.26524 10.3596 5.931 9.99164 5.69971 9.5599C5.46843 9.12817 5.34725 8.64603 5.34692 8.15625C5.34692 7.60179 5.49156 7.09554 5.75138 6.65625C6.49844 7.5759 7.43066 8.32806 8.48745 8.86384C9.54423 9.39961 10.7019 9.70702 11.8853 9.76607C11.4648 7.74375 12.9755 6.10714 14.7916 6.10714C15.6487 6.10714 16.4201 6.46607 16.9639 7.04464C17.6362 6.91875 18.2791 6.66696 18.8523 6.32946C18.63 7.01786 18.1639 7.59911 17.5451 7.96607C18.1451 7.90179 18.7237 7.73571 19.2594 7.50268C18.855 8.09732 18.3487 8.625 17.7675 9.04554Z"
              fill="#FFC727"
            />
          </g>
          <defs>
            <clipPath id="clip0_670_1422">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(0.000488281)"
              />
            </clipPath>
          </defs>
        </svg>
      </b-link>
    </li>
    <li>
      <b-link v-if="false" @click="handleGoToLinkedIn" class="linkedin">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.0005 0C5.37299 0 0.000488281 5.3725 0.000488281 12C0.000488281 18.6275 5.37299 24 12.0005 24C18.628 24 24.0005 18.6275 24.0005 12C24.0005 5.3725 18.628 0 12.0005 0ZM9.06299 16.9738H6.63299V9.15375H9.06299V16.9738ZM7.83299 8.19375C7.06549 8.19375 6.56924 7.65 6.56924 6.9775C6.56924 6.29125 7.08049 5.76375 7.86424 5.76375C8.64799 5.76375 9.12799 6.29125 9.14299 6.9775C9.14299 7.65 8.64799 8.19375 7.83299 8.19375ZM17.938 16.9738H15.508V12.64C15.508 11.6313 15.1555 10.9462 14.2767 10.9462C13.6055 10.9462 13.2067 11.41 13.0305 11.8563C12.9655 12.015 12.9492 12.24 12.9492 12.4638V16.9725H10.518V11.6475C10.518 10.6713 10.4867 9.855 10.4542 9.1525H12.5655L12.6767 10.2388H12.7255C13.0455 9.72875 13.8292 8.97625 15.1405 8.97625C16.7392 8.97625 17.938 10.0475 17.938 12.35V16.9738Z"
            fill="#FFC727"
          />
        </svg>
      </b-link>
    </li>
  </ul>
</template>

<script>
import SocialShare from "@/mixins/SocialShare.js";
export default {
  name: "SocialShare",
  mixins: [SocialShare],
  props: {
    isShare: {
      type: Boolean,
      required: false,
      default: false
    },
    igHandle: {
      type: String,
      required: false,
      default: "heartbeatfam"
    },
    twitterHandle: {
      type: String,
      required: false,
      default: "heartbeatfam"
    },
    fbHandle: {
      type: String,
      required: false,
      default: "heartbeatfam"
    },
    lInHandle: {
      type: String,
      required: false,
      default: "heartbeatfam"
    }
  },
  data() {
    return {};
  },
  methods: {
    handleGoToInstagram() {
      window.open(`https://instagram.com/${this.igHandle}`, "_blank");
    },
    handleGoToTwitter() {
      window.open(`https://twitter.com/${this.twitterHandle}`, "_blank");
    },
    handleGoToFacebook() {
      window.open(`https://facebook.com/${this.fbHandle}`, "_blank");
    },
    handleGoToLinkedIn() {
      window.open(`https://linkedIn.com/company/${this.lInHandle}`, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.social-links li {
  display: inline-block;
  margin-right: 5px;
}

.social-links li a {
  width: 32px;
  text-align: center;
  line-height: 35px;
  height: 32px;
  border-radius: 50%;
  color: #557efb;
}

.social-links li a i {
  width: 15px;
}

.social-links li a.facebook {
}

.social-links li a.facebook:hover {
  background: #1977f2;
  color: #ffffff;
}

.social-links li a.twitter {
  color: #38a1f3;
}

.social-links li a.twitter:hover {
  background: #1d9bf0;
  color: #ffffff;
}

.social-links li a.linkedin {
  //color: #0077b5;
}

.social-links li a.linkedin:hover {
  background: #0a66c2;
  color: #ffffff;
}

.social-links li a.instagram {
  color: #231f20;
}

.social-links li a.instagram:hover {
  background: #864db9;
  color: #ffffff;
}

.social-links li a:hover {
  //background: #557efb;
  color: #ffffff;
}
</style>
